import { BoundMultiSelectField, BoundSelectField, useComputed } from "@homebound/beam";
import { ObjectState } from "@homebound/form-state";
import { Observer } from "mobx-react";
import { useEffect, useState } from "react";
import { NamedFragment } from "src/fragments/commonFragments.generated";
import { ProjectTypeFilter } from "src/generated/graphqlTypes";
import { useBidScopeFieldsQuery } from "src/routes/bids/add-bid-package/components/BidScopeFields.generated";
import { PlanBasedBidPackagePage_OriginatingProjectFragment } from "src/routes/bids/plan-based-bid-package/PlanBasedBidPackagePage.generated";
import { PlanBasedBidPackageFormState } from "src/routes/bids/plan-based-bid-package/utils";

type PlanBasedBidPackageScopeFieldsProps = {
  formState: ObjectState<PlanBasedBidPackageFormState>;
  markets: NamedFragment[];
  originatingProject?: PlanBasedBidPackagePage_OriginatingProjectFragment;
};

export function PlanBasedBidPackageScopeFields(props: PlanBasedBidPackageScopeFieldsProps) {
  const { formState, markets, originatingProject } = props;
  const [prefillProjects, setPrefillProjects] = useState(!!originatingProject);
  const marketId = useComputed(() => formState.marketId.value, [formState.marketId.value]);
  const { data } = useBidScopeFieldsQuery({
    variables: { projectFilter: { market: [marketId!], type: [ProjectTypeFilter.Community] } },
    skip: !marketId,
  });

  const communities = (data?.projects ?? []).map((p) => ({ id: p.id, name: p.name }));

  useEffect(() => {
    if (prefillProjects && communities.nonEmpty && originatingProject) {
      const match = communities.find((c) => c.id === originatingProject.id);
      formState.projects.set(match ? [match.id] : []);
      setPrefillProjects(false);
    }
  }, [prefillProjects, communities, originatingProject, formState]);

  return (
    <Observer>
      {() => (
        <>
          {!originatingProject && (
            <BoundSelectField
              required
              options={markets}
              field={formState.marketId}
              onSelect={(option) => {
                formState.projects.set([]);
                formState.marketId.set(option);
              }}
            />
          )}
          {formState.marketId.value && (
            <BoundMultiSelectField
              label="Communities"
              options={communities}
              field={formState.projects}
              nothingSelectedText="All"
            />
          )}
        </>
      )}
    </Observer>
  );
}
